function addLinksToCarouselCards() {
   document.querySelectorAll('.scroll-trigger').forEach((carouselCard) => {
      carouselCard.addEventListener('click', (e) => {
         e.preventDefault();
         const clickedTrendSlideId = carouselCard.dataset?.trendId;
         document.dispatchEvent(
            new CustomEvent('scroll-to-trend-slide-id', {
               detail: {
                  trendId: clickedTrendSlideId,
               },
            })
         );
      });
   });
}

window.addEventListener('DOMContentLoaded', () => {
   addLinksToCarouselCards();
});
